import React, { Component } from 'react';
import loadingImage from '../img/loading.svg'

class Mainloading extends Component {

  render() {
      return (
        <div className="main-app-loading">
          <h1>
            نرم افزار مدیریت زمان هنگام
          </h1>
          <div>
            <img src={loadingImage} alt="loading" />
          </div>
          <h5>
            درحال دریافت اطلاعات از سرور ...
          </h5>
        </div>
      );
  }
}

export default Mainloading;